
type Credits = {
  modelCredits: number;
  photoPackCredits: number;
  redoCredits: number;
}

export function getCreditsForEntitlement(entitlement: string): Credits  {
  // Map your RevenueCat product IDs to credit amounts
  const productCredits: Record<string, Credits> = {
    // 1_pack
    '1_pack': {
      modelCredits: 0,
      photoPackCredits: 1,
      redoCredits: 0,
    },
     // 3_pack
     '3_pack': {
      modelCredits: 0,
      photoPackCredits: 3,
      redoCredits: 0,
    },
    // 5_pack
    '5_pack': {
      modelCredits: 0,
      photoPackCredits: 5,
      redoCredits: 0,
    },
    // 10_pack
    '10_pack': {
      modelCredits: 0,
      photoPackCredits: 10,
      redoCredits: 0,
    },
    // subscription
    'subscription': {
      modelCredits: 0,
      photoPackCredits: 1,
      redoCredits: 0,
    },
    // starter_kit
    '1_pack_1_model': {
      modelCredits: 1,
      photoPackCredits: 1,
      redoCredits: 0,
    },
    // pro_bundle
    '3_pack_1_model': {
      modelCredits: 1,
      photoPackCredits: 3,
      redoCredits: 0,
    },
    // redo
    'redo': {
      modelCredits: 0,
      photoPackCredits: 0,
      redoCredits: 1,
    }
    // Add more entitlements as needed
  };

  return productCredits[entitlement] || {
    modelCredits: 0,
    photoPackCredits: 0,
    redoCredits: 0,
  };
}
